<template>
  <div class="img-group task-shared-users justify-content-start">
    <img
      @click="$emit('on-setting')"
      role="button"
      :src="u.avator"
      v-for="(u, i) in usersObj.list"
      :key="`ozpqq_${i}`"
      class="img rounded-circle"
      alt=""
    />
    <slot name="mention"></slot>
    <!-- <div @click="$emit('on-mention', taskId)" class="pl-3">
      <v-avatar v-for="(u,i ) in usersObj.list" :key="i" class="ml-n3" color="white" style="border: 3px solid #FFF">
        <img    :src="u.avator" :style="{'filter': u.seen? 'none':'grayscale(100%)' }" />
      </v-avatar>
    </div> -->
  </div>
</template>

<script>
import { getTaskUsers } from "@/api/taskInUser";

export default {
  props: {
    taskId: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      usersObj: {
        list: []
      }
    };
  },
  mounted() {
    //console.log(this.taskId);
    this.init();
  },
  methods: {
    init() {
      
      getTaskUsers({
        params: { taskId: this.taskId, page: 0, size: 5 },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.usersObj.list = res.data.users;
          //console.log('tsk usrs frd 2', res.data.users.length);
          //this.$emit('on-task-users', res.data.users);
          //console.log('getTaskUsers', res);
        }
      });
    }
  }
};
</script>
